import React from 'react';

const SimpleTable = ({
  columns = [],
  data = [],
  /** Max height of the scroll area; table grows with rows up to this cap */
  scrollHeight = '60vh',
}) => {
  return (
    <div className="relative w-full min-h-0">
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden">
            <div
              className="overflow-y-auto shadow"
              style={{ maxHeight: scrollHeight }}
            >
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0 z-10">
                  <tr>
                    {columns.map((column, index) => (
                      <th
                        key={index}
                        scope="col"
                        className={`px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50 sticky top-0 ${column.headerClassName || 'text-left'}`}
                        style={{ position: 'sticky', top: 0, zIndex: 10 }}
                      >
                        {column.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {data.length > 0 ? (
                    data.map((row, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        {columns.map((column, colIndex) => (
                          <td key={colIndex} className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">
                              {column.renderCell ? column.renderCell(row) : (column.cell ? column.cell(row) : row[column.selector])}
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={columns.length} className="px-6 py-4 text-center text-sm text-gray-500">
                        No results found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleTable;